import { UI, HStack } from '@genial/components';
import { IconButton } from 'native-base';
import React from 'react';

export interface ProductTabletCardTopProps {
  isLoading?: boolean;
  mainInfo?: string;
  hasSecondaryInfo: boolean;
  isOpenSecondaryInfo: boolean;
  customHeaderButton?: React.ReactNode;
  customRecommendedPortfolioBadge?: React.ReactNode;
  onPressSecondaryInfo?: () => void;
}

export const ProductTabletCardTop: React.FC<ProductTabletCardTopProps> = ({
  isLoading,
  mainInfo = '',
  hasSecondaryInfo,
  isOpenSecondaryInfo,
  customHeaderButton,
  customRecommendedPortfolioBadge,
  onPressSecondaryInfo,
}) => {
  return (
    <HStack justifyContent="space-between" alignItems="center">
      <UI.Text textTransform="uppercase" variant="semibold" isLoading={isLoading}>
        {mainInfo}
      </UI.Text>
      <HStack space="inline.xxxs">
        {customRecommendedPortfolioBadge}
        {customHeaderButton}
        {!!hasSecondaryInfo && (
          <IconButton
            p={0}
            pr="inline.nano"
            variant="unstyled"
            onPress={onPressSecondaryInfo}
            icon={
              <UI.Icon
                name={isOpenSecondaryInfo ? 'ChevronUp' : 'ChevronDown'}
                size={'xxs'}
                color="neutral.black"
              />
            }
          />
        )}
      </HStack>
    </HStack>
  );
};
